module.exports = __webpack_public_path__ + "static/shadows-application-dont-75b736c246d7b1cb794d59bc91a6e1fd.png";